// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { FooterComponent, InputDropdownComponent } from '@openbank/ziniaweb-ui-components';
// Configurations
import { getIbanInputConfiguration } from './configurations/iban-selector.configurations';
// Constants
import {
  SELECT_IBAN_FOOTER_ACTION_PROPS,
  SELECT_IBAN_FOOTER_ACTION_LINK_PROPS,
  SELECT_IBAN_FOOTER_ACTION_BUTTON_PROPS,
} from './constants/iban-selector.component.constants';
// Hooks
import { useContractIbanSelectorHook } from './hooks/iban-selector.hook';
// Styles
import { SelectIbanContainerStyled } from './iban-selector.component.styled';
// Translations
import { CANCEL, CONTINUE } from './translations/iban-selector.translations';
// Types
import { IbanSelectorComponentType } from './types/iban-selector.component.type';

const IbanSelectorComponent = ({
  onCancel,
  onContinue,
}: IbanSelectorComponentType): React.JSX.Element => {
  const { disableSave, fetchingSave, formatMessage, handleChangeIban, ibanList } =
    useContractIbanSelectorHook();

  return (
    <SelectIbanContainerStyled>
      <InputDropdownComponent
        {...getIbanInputConfiguration({ ibanList, formatMessage, handleChangeIban })}
      />
      <FooterComponent
        {...SELECT_IBAN_FOOTER_ACTION_PROPS}
        buttonGhostConfiguration={{
          ...SELECT_IBAN_FOOTER_ACTION_LINK_PROPS,
          children: <FormattedMessage id={CANCEL} />,
          onClick: () => onCancel(),
          disabled: fetchingSave,
        }}
        mainButtonConfiguration={{
          ...SELECT_IBAN_FOOTER_ACTION_BUTTON_PROPS,
          children: <FormattedMessage id={CONTINUE} />,
          onClick: () => onContinue(),
          disabled: disableSave,
          loading: fetchingSave,
        }}
      />
    </SelectIbanContainerStyled>
  );
};

export { IbanSelectorComponent };
